export var UserActions = {
    updateUser: "UPDATE_USER"
};
export var updateUser = function(user) {
    return {
        type: UserActions.updateUser,
        payload: {
            user: user
        }
    };
};

//# sourceMappingURL=UserActions.js.map